var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddcustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e93565",
    d: "M28.22 45.76s-5.62 3.358-13.907 3.676c0 0-7.609.79-8.377-3.2 0 0-.41-14.775 2.19-17.938 0 0 2.411-2.82 6.957-5.338l1.313-1.634s2.699 4.2 8.03 4.31c0 0 1.923-2.572 1.923-6.081l.818-1.458s2.33-1.115 4.127 1.216c.038.049.075.1.113.152 0 0 3.638 4.471 2.728 17.151 0 0-.343 5.86-5.915 9.144z",
    className: "colore93565 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M28.958 41.225c-.129 1.97-.361 3.581-.738 4.535a424.375 424.375 0 0 0-1.781-3.254c-3.513-6.354-7.321-12.883-11.356-19.546l1.313-1.634s2.699 4.2 8.03 4.31c0 0 1.923-2.572 1.923-6.081l.818-1.458 1.15 2.74c.038.38.078.82.12 1.31.388 4.526.895 13.332.52 19.078z",
    className: "colorfff svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b28afd",
    d: "M28.957 41.224c-.127 1.971-.36 3.583-.737 4.538a462.31 462.31 0 0 0-1.78-3.256c-.433-1.863-.828-4.067-1.198-6.492-.369-2.423-.712-5.065-1.049-7.803l-.708.01-.515-1.746 1.456-.84 2.117.212v1.105l-.894.694 3.308 13.578z",
    className: "colorb28afd svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5c9c6",
    d: "M16.46 18.835v3.935l5.819 3.417 2.147-.551s2.24-2.835 2.31-2.866-.387-3.215-.387-3.215l-4.697-4.024-5.191 3.304z",
    className: "colorf5c9c6 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#edeef2",
    d: "M24.426 25.636c-.576.832-.901 2.022-1.066 3.44-4.216-1.004-6.892-3.101-8.277-6.116l1.313-1.634s2.699 4.2 8.03 4.31zM28.437 22.147c-.006 1.312-.195 2.526-.563 3.645a10.166 10.166 0 0 1-.857 1.917c-.581-1.17-1.472-1.815-2.591-2.073 0 0 1.853-2.633 1.853-6.142l.888-1.397 1.198 2.856c.031.385.053.788.072 1.194z",
    className: "coloredeef2 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc104a",
    d: "M28.22 45.76c.893-5.105.353-12.355-.346-19.968-.234-2.546-.486-5.134-.707-7.695l1.15 2.74.048.116 2.91 6.928-.505 3.532.626 3.688c-.879 4.4-1.518 8.208-3.176 10.66z",
    className: "colorcc104a svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4d6d4",
    d: "M28.121 10.022c.482 6.248-.954 8.075-.954 8.075-2.728 5.62-8.93 2.296-10.706.738-1.777-1.558-2.87-4.926-2.87-4.926a10.2 10.2 0 0 1-.386-1.108c-.534-1.878-.437-3.626-.098-5.09C14.46 1.886 21.506-.495 26.02 3.427c.747.65 1.32 1.392 1.674 2.118 1.464 3.004.447 4.45.429 4.477z",
    className: "colorf4d6d4 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#51383c",
    d: "M28.699 5.36c-.615-.506-1.93-1.28-2.68-1.93-4.51-3.93-11.56-1.54-12.91 4.28-.34 1.46-.44 3.21.1 5.09 1.27-.84 2.05-.31 2.48.27.27.37.41.82.44 1.28.03.61.15 1.63.55 1.65.56.04.57-.76.57-.76.42-2.53 1.58-3.56 1.58-3.56.46-.64 1.02-.65 1.38-.55.19.05.37.15.53.26 1.14.8 3.36.44 3.36.44 2.72-.24 4.858-1.48 4.858-1.48.02-.03 3.854-1.599-.258-4.99z",
    className: "color51383c svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc104a",
    d: "m15.178 22.898 3.785 13.409 2.298-.672.252 3.127c2.335 2.442 6.502 7.032 6.716 6.985l-1.696-3.304-11.355-19.545z",
    className: "colorcc104a svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#78e75a",
    d: "M43.36 30.777c-1.085-.632-.296 3.436-1.956 4.39-3.274 1.886-3.62 4.168-3.612 7.933 0 1.877-3.914 1.537-2.848 2.16l-1.99-1.16c-1.067-.623-1.727-1.944-1.737-3.822-.01-3.765 2.642-8.35 5.916-10.247 1.651-.952 3.152-1.038 4.227-.415l2 1.16z",
    className: "color78e75a svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#72d561",
    d: "M39.129 31.191c3.283-1.895 5.948-.376 5.959 3.39.01 3.779-2.638 8.365-5.92 10.261-3.278 1.892-5.943.373-5.954-3.406-.01-3.766 2.638-8.353 5.915-10.245z",
    className: "color72d561 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M39.139 33.63c.481-.278.868-.05.87.496l.007 2.395 2.084-1.203c.476-.275.863-.047.864.492.002.554-.382 1.22-.858 1.495l-2.085 1.203.007 2.395c.002.554-.383 1.22-.865 1.498-.475.274-.868.058-.87-.496l-.007-2.395-2.084 1.203c-.47.271-.863.054-.864-.5-.002-.54.389-1.215.858-1.487l2.085-1.203-.007-2.395c-.002-.547.389-1.223.865-1.498z",
    className: "colorfff svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcustomer);
export default __webpack_public_path__ + "static/media/addcustomer.88579b71ab0a822c0afff8be66ef3923.svg";
export { ForwardRef as ReactComponent };